import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, OnInit, inject } from '@angular/core';

import { ScrollContainerService } from '@frontend/sports/common/core/utils/scroll-container';
import { ColumnLayoutService, LayoutColumn } from '@frontend/sports/layout/feature';
import { ModalDialogContainerDirective } from '@frontend/sports/modal/feature';
import { WidgetRightColumnContent, WidgetRightColumnService } from '@frontend/sports/widget/core/feature';
import { WidgetSlotComponent } from '@frontend/sports/widget/feature/slot';
import { Observable } from 'rxjs';

@Component({
    selector: 'ms-widget-column',
    templateUrl: './widget-column.component.html',
    providers: [ScrollContainerService],
    imports: [WidgetSlotComponent, AsyncPipe, ModalDialogContainerDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetColumnComponent implements OnInit {
    private scrollContainer = inject(ScrollContainerService);
    private elementRef = inject(ElementRef);
    private columnLayout = inject(ColumnLayoutService);

    content$: Observable<WidgetRightColumnContent>;

    constructor() {
        const service = inject(WidgetRightColumnService);

        this.content$ = service.asObservable();
    }

    ngOnInit(): void {
        this.columnLayout.register({
            component: WidgetColumnComponent,
            location: LayoutColumn.Right,
        });

        this.scrollContainer.setTarget(this.elementRef.nativeElement);
    }
}
